import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, Wallet, IdentificationCard } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

export default function Kelola() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const items = [
    { key: "siswa", label: "Data Siswa", icon: IdentificationCard, path: "/kelola/siswa", color: "bg-sky-100 text-sky-600" },
    ...(user?.role === "admin"
      ? [
          { key: "spp", label: "Kelola SPP", icon: Wallet, path: "/kelola/spp", color: "bg-orange-100 text-orange-600" },
        ]
      : []),
  ];

  return (
    <div className="pt-6">
      <div className="px-5 mb-5">
        <h1 className="font-heading text-2xl font-bold text-stone-800">Kelola Data 🗂️</h1>
        <p className="text-stone-500 text-sm">Input & atur data sekolah</p>
      </div>
      <div className="px-5 grid grid-cols-2 gap-3">
        {items.map((m, i) => {
          const Icon = m.icon;
          return (
            <motion.button
              key={m.key}
              data-testid={`kelola-${m.key}`}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.04 }}
              onClick={() => navigate(m.path)}
              className="bg-white rounded-3xl border border-stone-200/60 p-4 shadow-sm flex items-center gap-3 active:scale-95 transition-transform"
            >
              <div className={`w-12 h-12 rounded-2xl ${m.color} flex items-center justify-center`}>
                <Icon size={24} weight="duotone" />
              </div>
              <span className="font-heading font-semibold text-stone-700 text-sm">{m.label}</span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}
